var _path, _ellipse, _ellipse2, _path2, _path3, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContractGroupHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 408,
    height: 551,
    viewBox: "0 0 408 551",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.02 75.187L64.1906 93.1293L41.3217 171.066",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.1457,
    cy: 95.3317,
    rx: 12.4939,
    ry: 12.4678,
    transform: "rotate(138.58 63.1457 95.3317)",
    fill: "#4D4ABF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.46134,
    ry: 5.45063,
    transform: "matrix(-0.853551 0.521009 -0.520397 -0.853925 40.7505 171.036)",
    fill: "#4D4ABF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195.283 82.3497C191.679 78.2638 192.074 72.0201 196.172 68.4045C200.27 64.7889 206.515 65.1752 210.119 69.2611C213.724 73.3471 213.329 79.5907 209.231 83.2063C205.132 86.822 198.888 86.4357 195.283 82.3497Z",
    fill: "white",
    stroke: "#4D4ABF",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M294.074 529.913L393.118 449.935",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 392.875,
    cy: 447.682,
    r: 11.6013,
    transform: "rotate(-72.8711 392.875 447.682)",
    fill: "#4D4ABF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.644,
    cy: 530.723,
    r: 9.11392,
    transform: "rotate(-72.8711 291.644 530.723)",
    fill: "white",
    stroke: "#4D4ABF",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractGroupHero);
export default __webpack_public_path__ + "static/media/contract-group-hero.fa703a09defd6055085700523de8c295.svg";
export { ForwardRef as ReactComponent };